import { featuresContent } from '../../data/homeContent';

const FeatureCard = ({ icon: Icon, title, description, gradient }) => (
  <div
    className={`
      group relative bg-white p-6 rounded-2xl shadow-lg
      hover:shadow-2xl transition-all duration-300
      border border-gray-100
      overflow-hidden
      hover:scale-105
      hover:-translate-y-2
      cursor-pointer
      flex flex-col items-center justify-center text-center
    `}
    style={{ willChange: 'transform' }}
  >
    <div
      className={`
        absolute -top-8 -right-8 w-32 h-32 rounded-full opacity-20 blur-2xl
        z-0
        bg-gradient-to-br ${gradient}
        transition-all duration-500 group-hover:scale-125
      `}
    />
    <div className="relative z-10 flex items-center justify-center mb-4">
      <span
        className={`
          text-4xl text-white p-3 rounded-full shadow-lg
          bg-gradient-to-tr ${gradient}
          transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110
        `}
      >
        <Icon />
      </span>
    </div>
    <h3 className="text-xl font-bold mb-2 text-gray-800 relative z-10">{title}</h3>
    <p className="text-gray-600 relative z-10">{description}</p>
  </div>
);

const Features = ({from=''}) => {
  const { title, subtitle, features } = featuresContent;

  return (
    <div className={`${from === "Features"?"py-0":"py-20"}bg-white`}>
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4">{title}</h2>
        <p className="text-xl text-gray-600 text-center mb-12">{subtitle}</p>
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features; 